export const getScenarioButtonText = (scenario) => {
  let text = '';
  switch (scenario) {
    case 'lobby':
    case 'meeting':
      text = 'Confirm your settings';
      break;
    case 'dashboard':
      text = 'Back to dashboard';
      break;
    default:
      text = window.history.length > 1 ? 'Return' : 'Close';
  }
  return text;
};
